import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Project, ProjectReclaimSearch, ProjectRequest, ProjectSearchRequest } from './ProjectTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Project>>('/author/projects/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Project>(`/author/projects/${id}`).then(getData);
}

export function edit(id: Id, request: ProjectRequest) {
  return axios.put<Project>(`/author/projects/${id}`, request).then(getData);
}

export function create(request: ProjectRequest) {
  return axios.post<Project>(`/author/projects`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/projects/${id}`).then(getData);
}

export function searchByIdentifiers(request: ProjectSearchRequest) {
  return axios
    .get<ProjectReclaimSearch>('/author/projects/search/by-id', {
      params: {
        ...request,
      },
    })
    .then(getData);
}

export function reclaimAuthorship(projectId: number, authorId: number) {
  return axios.post<unknown>(`/author/projects/${projectId}/reclaim-authorship/${authorId}`).then(getData);
}
